/* eslint-disable no-unused-vars */
import { bool, func, oneOf, string } from "prop-types";
import React from "react";

import "./checkbox.scss";

export const Checkbox = ({ checked, onChange, shape, className, label, labelClassName }) => {
	return (
		<div id="inputPreview" onClick={onChange}>
			<div className={`checkbox-wrapper ${shape ?? "square"}`}>
				<input type="checkbox" checked={checked} onChange={onChange} />
				<div className="checkbox">{checked && <div className="checkbox-checked" />}</div>
			</div>
			<div className={`checkbox__label ${labelClassName}`}>{label}</div>
		</div>
	);
};

Checkbox.propTypes = {
	checked: bool,
	onChange: func,
	shape: oneOf(["square", "circle"]),
	className: string,
	label: string,
	labelClassName: string,
};
